import { Translatable } from '@app/types/translatable.type';

const ChangeRequestTemplateDisplayOptions: { [key: string]: string } = {
    Compensation: 'template.compensation',
    Position: 'template.position',
    Promotion: 'template.promotion',
    'Employment Type': 'template.employmentType',
    'Job Information': 'template.jobInformation',
};

const ChangeRequestTemplateFieldOptions: { [key: string]: Translatable } = {
    'Compensation Type': 'field.compensationType',
    'Compensation Rate': 'field.compensationRate',
    'Hours per Week': 'field.hoursPerWeek',
    'End Date': 'field.endDate',
    'Vacation Pay': 'field.vacationPay',
    'Reports to': 'field.reportsTo',
    Department: 'field.department',
    Position: 'field.position',
    'Employment Type': 'field.employmentType',
    'Stock Options': 'field.stockOptions',
    Location: 'field.location',
};

export { ChangeRequestTemplateDisplayOptions, ChangeRequestTemplateFieldOptions };
